import Exif from 'exif-js'

/**
 * getUrlKey 截取地址栏参数
 * @param value
 * @returns {String}
 */
function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
        location.href
      ) || [, ''])[1].replace(/\+/g, '%20')
    ) || null
  );
}

function compress(file, quality, callback) {

  let Orientation;

  //去获取拍照时的信息，解决拍出来的照片旋转问题 

  Exif.getData(file, function () {

    Orientation = Exif.getTag(this, 'Orientation');

  });

  if (!window.FileReader || !window.Blob) {

    return errorHandler('您的浏览器不支持图片压缩')();

  }

  var reader = new FileReader();

  var mimeType = file.type || 'image/jpeg';

  reader.onload = createImage;

  reader.onerror = errorHandler('图片读取失败！');

  reader.readAsDataURL(file);

  function createImage() {

    var dataURL = this.result;

    if(dataURL.length <= 500 * 1024){
      quality = 1.0;//不压缩
      console.log("压缩质量"+'1.0');
    }else if(dataURL.length >= 1000 * 1024 && dataURL.length <= 5000 * 1024){
      quality = 0.3;//压缩
      console.log("压缩质量"+'0.3');
    }else if(dataURL.length > 5000 * 1024){
      quality = 0.1;//压缩质量
      console.log("压缩质量"+'0.1');
    }

    var image = new Image();

    image.onload = compressImage;

    image.onerror = errorHandler('图片加载失败');

    image.src = dataURL;

  }
  // 压缩图片
  function compressImage() {

    var canvas = document.createElement('canvas');

    var ctx;

    var dataURI;

    var result;

    var degree = 0, drawWidth, drawHeight, width, height;

    drawWidth = this.naturalWidth;

    drawHeight = this.naturalHeight;

    canvas.width = width = drawWidth;

    canvas.height = height = drawHeight;

    ctx = canvas.getContext('2d');

    //判断图片方向，重置canvas大小，确定旋转角度，iphone默认的是home键在右方的横屏拍摄方式

    if (Orientation != "" && Orientation != 1) {

      switch (Orientation) {

        //iphone横屏拍摄，此时home键在左侧

        case 3:

          degree = 180;

          drawWidth = -width;

          drawHeight = -height;

          break;

        //iphone竖屏拍摄，此时home键在下方(正常拿手机的方向)

        case 6:

          canvas.width = height;

          canvas.height = width;

          degree = 90;

          drawWidth = width;

          drawHeight = -height;

          break;

        //iphone竖屏拍摄，此时home键在上方

        case 8:

          canvas.width = height;

          canvas.height = width;

          degree = 270;

          drawWidth = -width;

          drawHeight = height;

          break;

      }

    }

    //使用canvas旋转校正

    ctx.rotate(degree * Math.PI / 180);

    ctx.drawImage(this, 0, 0, drawWidth, drawHeight);

    dataURI = canvas.toDataURL(mimeType, quality);

    result = dataURIToBlob(dataURI);

    callback(null, result);

  }
  
  function dataURIToBlob(dataURI) {

    var type = dataURI.match(/data:([^;]+)/)[1];

    var base64 = dataURI.replace(/^[^,]+,/, '');

    var byteString = atob(base64);

    var ia = new Uint8Array(byteString.length);

    for (var i = 0; i < byteString.length; i++) {

      ia[i] = byteString.charCodeAt(i);

    }

    var blob;

    try {

      blob = new Blob([ia], { type: 'image/jpg' });

    } catch (e) {

      window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;

      if (e.name === 'TypeError' && window.BlobBuilder) {

        var blobBuilder = new BlobBuilder();

        blobBuilder.append(ia);

        blob = blobBuilder.getBlob('image/jpg');

      }

    }

    return blob

  }


  function errorHandler(message) {

    return function () {

      var error = new Error('Compression Error:', message);

      callback(error, null);

    };

  }

}


function getBaseUrl(){

  return process.env.NODE_ENV === 'production' ? 'http://123.57.60.233:8009' : '';
}





export default {
  getUrlKey,
  compress,
  getBaseUrl,
};
 